import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Toast {
	id: number;
	type: 'success' | 'error' | 'warning' | 'info';
	title?: string;
	message: string;
	timeout?: number;
	iconUrl?: string;
}

@Injectable({
	providedIn: 'root'
})
export class ToastService {
	private toastsSubject = new Subject<Toast>();
	public toasts$ = this.toastsSubject.asObservable();

	constructor() {
	}

	success(message: string, title?: string, timeout: number = 3000): void {
		this.show('success', message, title, timeout);
	}

	error(message: string, title?: string, timeout: number = 5000): void {
		this.show('error', message, title, timeout);
	}

	warning(message: string, title?: string, timeout: number = 4000): void {
		this.show('warning', message, title, timeout);
	}

	info(message: string, title?: string, timeout: number = 3000): void {
		this.show('info', message, title, timeout);
	}

	custom(type: 'success' | 'error' | 'warning' | 'info', message: string, title?: string, timeout: number = 3000, iconUrl?: string): void {
		this.show(type, message, title, timeout, iconUrl);
	}

	private generateUniqueId(): number {
		return Date.now() + Math.floor(Math.random() * 10000);
	}

	private show(type: 'success' | 'error' | 'warning' | 'info', message: string, title?: string, timeout?: number, iconUrl?: string): void {
		const toast: Toast = {
			id: this.generateUniqueId(),
			type,
			title,
			message,
			timeout,
			iconUrl
		};

		this.toastsSubject.next(toast);
	}
}
